// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"Dashboard_dashboard__2Azyh","topbar":"Dashboard_topbar__P2iZi"};